export const scrollOnHoverSxProps = {
    // Preserve padding even when the scrollbar is not present
    scrollbarGutter: "stable",
    // Hide scrollbar thumb initially
    "&::-webkit-scrollbar-thumb": {
        visibility: "hidden"
    },
    // Display scrollbar thumb when hovering over the container
    "&:hover::-webkit-scrollbar-thumb": {
        visibility: "visible"
    }
};
//# sourceMappingURL=scrollUtils.js.map